export const h = {
	quantity: "在庫あり",
	brand: "ブランド",
	sku: "SKU",
	model: "モデル",
	addCart: "ショッピングカートに入れる",
	buyNow: "今買う",
	productDetail: " 製品詳細",
	attribute: "Attribute",
	quantityExits: "在庫あり",
	quantityNone: "在庫切れ",

	// 账单页面
	email: "メールボックス",
	errorEmail: "正しいメールアドレスを入力してください",

	contact: '連絡先',
	sippingAddress: '配送先住所',
	name: "姓名",
	nameError: "お名前を入力してください",
	address1: "住所1",
	address1Error: "住所を入力してください1",

	address2: "住所2",
	emailCode: "郵便番号",

	phone: "携帯電話番号",
	city: "都市",
	cityError: "都市を入力してください",
	country: "国家",
	countryError: "国を入力してください",
	province: "省",
	provinceError: "州を入力してください",
	payWay: "支払い方法",
	sendWay: "配送方法",
	loginText: "ログイン / 登録",
	cartNum: "ショッピングカートの総数",
	orderRemarks: "注文備考",
	discountCode: "割引コードを入力してください",
	apply: "アプリケーション",
	submitOrder: "注文を提出する",

	classify: "カテゴリー",
	price: "価格",
	allNum: "合計数",
	defaultTit: "デフォルト",
	salesLowToHigh: "売上数（低→高）",
	salesHighToLow: "売上数（高→低）",
	nameAtoZ: "商品名（あ→ん）",
	nameZtoA: "商品名（ん→あ）",
	priceLowtoHeight: "価格（安い→高い）",
	priceHeighttoLow: "価格（高い→安い）",
	selectClassfiy: "カテゴリーを選択",
	goodCart: "ショッピングカート",
	checkout: "レジへ進む",
	pay: "支払う",
	goods: "商品",
	num: "数量",
	total: "小計",
	action: "操作",
	del: "削除",
	priceTotal: "合計金額",
	all: "すべて",
	selectd: "選択済み",
	goCheckout: "決済へ進む",
	linkGoods: "関連商品",
	noData: "データがありません",
	myOrder: "注文履歴",
	changeUserInfo: "会員情報変更",
	changePassword: "パスワード変更",
	myAddress: "配送先住所",
	myWishlist: "お気に入り",
	myRmas: "アフターサービス",
	userCommission: "会員報酬",
	commissionUsers: "紹介関係",
	loginOut: "ログアウト",
	orderId: "注文番号",

	lookDetail: "詳細を見る",
	saleService: "アフターサービスを申請",
	confirmReceivedGoods: "受け取り確認",
	goPay: "支払いへ進む",
	cancelOrder: "注文をキャンセル",

	orderDetail: "注文詳細",
	created_at: "注文日時",
	status_format: "注文ステータス",
	total_format: "注文金額",
	payment_method_name: "支払方法",
	shipping_method_name: "配送方法",

	addressInfo: "住所情報",
	name: "氏名",
	address: "住所",
	payGoods: "注文商品",

	sendCompany: "配送会社",
	sendNum: "配送伝票番号",
	updateTime: "更新日時",
	memo: "備考",
	payOrderAddress: "請求先住所",
	allOrder: "すべての注文",
	waitPay: "入金待ち",
	waitSend: "発送待ち",
	waitReceiving: "配送中",
	completed: "完了",
	confirm: "確認",
	tips: "注意事項",
	cancel: "キャンセル",
	changeHeadImg: "プロフィール画像変更",
	uploadTit: "JPEGまたはPNG画像をアップロード（推奨サイズ：300×300）",
	imgSizeTips: "画像サイズは2MB以内にしてください",
	imgTypeTips: "JPG/PNG形式のみ対応",
	serviceType: "サービス種類",
	returnNum: "返品数量",
	isOpend: "開封済みですか",
	returnReason: "返品理由",
	yes: "はい",
	no: "いいえ",
	returnGoods: "返品",
	exchange: "交換",
	repair: "修理",
	reissue: "再発送",
	refund: "返金のみ",
	returnNumError: "返品数量を入力してください",

	oldPassword: "現在のパスワード",
	newPassword: "新しいパスワード",
	confirmNewPassword: "新しいパスワード（確認）",

	wishlist: "お気に入りから削除",
	look: "閲覧",
	opendPkg: "開封済み",
	img: "画像",
	afterSales: "アフターサービス詳細",

	balance: "利用可能残高",
	waitAmount: "未決済金額",
	withdrawaled: "出金済み",
	withdrawal: "出金",
	allCommission: "総報酬額",
	startTime: "開始日時",
	endTime: "終了日時",
	search: "検索",

	rebateLevel: "報酬レベル",
	CommissionRate: "報酬率",
	commission: "報酬",
	settlementStatus: "決済状況",
	time: "日時",
	WithdrawalAmount: "出金額",
	peleaseSelect: "選択してください",
	withdrawalUser: "出金口座",
	peleaseIpt: "入力してください",
	submitSuccess: "送信完了",
	shareLink: "リンクを共有",
	superior: "上位会員",
	wu: "なし",
	subordinate: "下位会員",
	addTime: "登録日時",
	userAccount: "アカウント",
	recommendationCode: "紹介コード",
	copySuccess: "コピーしました",
	subPay: "支払いを確定",
	iptCardholder_Name: "カード名義人を入力",

	copy: "複製（ふくせい）",

	"home": "ホーム",
	"categoriesPage": "カテゴリ",
	"brandsPage": "ブランド",
	"brandsPageList": "ブランド商品",
	"productsPage": "商品",
	"wishlistPage": "マイリスト",
	"accountPage": "マイオーダー",
	"cartsPage": "ショッピングカート",
	"checkoutPage": "決済",
	"passwordPage": "パスワード変更",
	"editPage": "情報変更",
	"addressesPage": "住所変更",
	"rmasPage": "会員関係",
	"commissionPage": "会員コミッション",
	"success_order_checkoutPage": "注文支払い",
	"page_categoriesPage": "記事カテゴリ",
	"userloginPage": "ログイン",
	"pagesPage": "記事",

	hotGoods: "人気商品",
	newGoods: "新着商品",
	visitGoods: "閲覧数ランキング",
	allGoods: "全ての商品",
	evaluation: "レビュー",

	"first_name": "名字",
	"first_nameError": "名字を入力してください",
	"last_name": "名前",
	"last_nameError": "名前を入力してください",

	"comment": "コンテンツ",
	"noContent": "コメントはまだありません",
	"author": "作者",
	"scoreNum": "評価",
	"commentTit": "コメント",
	send: "送信",


	noPayWay: "利用可能な支払い方法がありません",
	noTransportation: "利用可能な配送方法がありません",
	
	"tkyouorder": "ご注文ありがとうございます",
	  "orderDate": "注文日",
	  "ordeAmount": "注文金額",
	  "paymentAddress": "支払い先住所",
	  "zipCode": "郵便番号",
	  customizationFee: "カスタマイズ料金"
}